import { Translate } from '../../../shared/LanguageService';
import { PreviewAudience } from './newsPreviewAudience';

export function describeAudience(audience: PreviewAudience): string[] {
    if (audience.kind === 'no-recipients') {
        return [Translate('news-editor-modal/no-recipients')];
    }
    if (audience.kind === 'not-recipient') {
        return [Translate('news-editor-preview/not-recipient')];
    }
    if (audience.kind === 'no-dates') {
        return [Translate('news-editor-preview/no-dates')];
    }

    const lines = [
        audience.until
            ? Translate('news-editor-preview/shown-from-until', {
                  from: audience.from,
                  until: audience.until
              })
            : Translate('news-editor-preview/shown-from', { from: audience.from })
    ];
    if (audience.brokerChainCount !== null) {
        lines.push(
            Translate('news-editor-preview/only-broker-chains', {
                count: audience.brokerChainCount
            })
        );
    }
    return lines;
}
